import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
} from "vue-router";

// 根据域名判断应该加载哪个默认路由
const isFynixIMDomain =
  window.location.hostname === "www.fynix.im" ||
  window.location.hostname === "fynix.im";
const isAISHOPLanding = window.location.hostname === "aishop-invite.fynix.im";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: () => {
      // 如果是 www.fynix.im 域名,加载 website/index.vue
      // 如果是 aishop.fynix.im 域名,加载 landing/index.vue
      // 其他域名加载 views/index.vue
      if (isAISHOPLanding) {
        return import("@/views/landing/index.vue");
      }
      if (isFynixIMDomain) {
        return import("@/views/website/index.vue");
      }
      return import("../views/index.vue");
    },
    meta: {
      title: "Fynix AI",
    },
  },
  {
    path: "/views-index",
    name: "home",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/index.html",
    redirect: "/views-index",
  },
  {
    path: "/product-demo",
    name: "product-demo",
    component: () => import("../views/product-demo.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("../views/contact-us.vue"),
  },
  {
    path: "/website/home",
    name: "websiteHome",
    component: () => import("@/views/website/index.vue"),
    meta: {
      title: "Fynix AI Shop: Your Digital Workforce",
    },
  },
  {
    path: "/website/laws",
    name: "websiteLaws",
    component: () => import("@/views/website/laws.vue"),
    meta: {
      title: "Fynix AI Shop: Your Digital Workforce",
    },
  },
  {
    path: "/website/contact",
    name: "websiteContact",
    component: () => import("@/views/website/contact.vue"),
    meta: {
      title: "Fynix AI Shop: Your Digital Workforce",
    },
  },
  {
    path: "/landing/home",
    name: "landingHome",
    component: () => import("@/views/landing/index.vue"),
    meta: {
      title: "Fynix AI",
    },
  },
  {
    path: "/landing/laws",
    name: "landingLaws",
    component: () => import("@/views/landing/laws.vue"),
    meta: {
      title: "Fynix AI",
    },
  },
];

const router = createRouter({
  history: createWebHistory(
    process.env.VUE_APP_PUBLIC_PATH || process.env.BASE_URL
  ),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// Update document title based on route meta
router.afterEach((to) => {
  const title = to.meta.title as string;
  if (title) {
    document.title = title;
  }
});

export default router;
